const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  loading: false,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearLoading: (state) => {
      state.loading = false;
    },
  },
});

export const { setLoading, clearLoading } = loaderSlice.actions;
export const selectLoading = (state) => state.loader.loading;

export default loaderSlice.reducer;
